import {EventEmitter} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {IFilter} from '../services/IFilter';

export class ApiKeyFilter implements IFilter {
  anyChange: EventEmitter<any> = new EventEmitter<any>();

  nameChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  apiKeyChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  companyIdChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  proxyUserIdChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  serviceChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  disabledChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor() {
    this.clear();
  }

  get name(): any {
    return this.nameChange.value;
  }

  set name(name: any) {
    this.nameChange.next(name);
    this.emitChange('name', name);
  }

  get apiKey(): any {
    return this.apiKeyChange.value;
  }

  set apiKey(apiKey: any) {
    this.apiKeyChange.next(apiKey);
    this.emitChange('apiKey', apiKey);
  }

  get companyId(): any {
    return this.companyIdChange.value;
  }

  set companyId(companyId: any) {
    this.companyIdChange.next(companyId);
    this.emitChange('companyId', companyId);
  }

  get proxyUserId(): any {
    return this.proxyUserIdChange.value;
  }

  set proxyUserId(proxyUserId: any) {
    this.proxyUserIdChange.next(proxyUserId);
    this.emitChange('proxyUserId', proxyUserId);
  }

  get service(): any {
    return this.serviceChange.value;
  }

  set service(service: any) {
    this.serviceChange.next(service);
    this.emitChange('service', service);
  }

  get disabled(): any {
    return this.disabledChange.value;
  }

  set disabled(disabled: any) {
    this.disabledChange.next(disabled);
    this.emitChange('disabled', disabled);
  }

  emitChange(prop: string, value: any): void {
    this.anyChange.emit({prop, value});
  }

  getParams(): HttpParams {
    let params = new HttpParams();

    if (this.name) {
      params = params.set('name', this.name);
    }
    if (this.apiKey) {
      params = params.set('apiKey', this.apiKey);
    }
    if (this.companyId) {
      params = params.set('companyId', this.companyId);
    }
    if (this.proxyUserId) {
      params = params.set('proxyUserId', this.proxyUserId);
    }
    if (this.service) {
      params = params.set('service', this.service);
    }
    if (this.disabled !== undefined && this.disabled !== null && this.disabled !== '') {
      params = params.set('disabled', this.disabled);
    }

    return params;
  }

  setFilters(props: any): void {
    this.nameChange.next(props.name || undefined);
    this.apiKeyChange.next(props.apiKey || undefined);
    this.companyIdChange.next(props.companyId || undefined);
    this.proxyUserIdChange.next(props.proxyUserId || undefined);
    this.serviceChange.next(props.service || undefined);
    this.disabledChange.next(props.disabled ?? undefined);
  }

  toObj(): any {
    return {
      name: this.name,
      apiKey: this.apiKey,
      companyId: this.companyId,
      proxyUserId: this.proxyUserId,
      service: this.service,
      disabled: this.disabled,
    };
  }

  clear(): void {
    this.name = undefined;
    this.apiKey = undefined;
    this.companyId = undefined;
    this.proxyUserId = undefined;
    this.service = undefined;
    this.disabled = undefined;
  }
}
